export default function (value) {
  if (!value) {
    return '0'
  }
  return parseFloat(value)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$& ')
    .replace('.', ',')
}
